const INITIAL_SORT_STATE = {
  name: 'ASC',
  createdAt: null,
};

export { INITIAL_SORT_STATE };
